import { render } from "./StaffRoles.vue?vue&type=template&id=6d0075ad&ts=true"
import script from "./StaffRoles.vue?vue&type=script&lang=ts"
export * from "./StaffRoles.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__